import type { ReactNode } from 'react';

type UiDatePickerCellProps = {
    label: string;
    /** The one cell in the grid's tab order (roving tabindex). */
    focused: boolean;
    selected: boolean;
    /** Today, this month or this year. */
    current: boolean;
    disabled: boolean;
    /** A day of the neighbouring month. */
    outside?: boolean;
    onClick: () => void;
    children: ReactNode;
};

/** One day, month or year. States are ARIA attributes, which the stylesheet reads as well. */
export function UiDatePickerCell({
    label,
    focused,
    selected,
    current,
    disabled,
    outside = false,
    onClick,
    children,
}: UiDatePickerCellProps) {
    return (
        <button
            type="button"
            className="form-datepicker-cell"
            tabIndex={focused ? 0 : -1}
            aria-label={label}
            aria-pressed={selected}
            aria-current={current ? 'date' : undefined}
            aria-disabled={disabled || undefined}
            data-outside={outside || undefined}
            data-focused={focused || undefined}
            onClick={disabled ? undefined : onClick}
        >
            {children}
        </button>
    );
}
